const IconMoney = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#FF3333" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0046 29H12.9954C12.4457 29 12 28.549 12 27.9957V24.0043C12 23.4496 12.4491 23 12.9954 23H14V21H12.9954C12.4457 21 12 20.549 12 19.9957V17H10.9954C10.4457 17 10 16.549 10 15.9957V12.0043C10 11.4496 10.4491 11 10.9954 11H19.0046C19.5543 11 20 11.451 20 12.0043V15H21.0046C21.5543 15 22 15.451 22 16.0043V19H25C27.7614 19 30 21.2386 30 24C30 26.7614 27.7614 29 25 29C23.8744 29 22.8357 28.6281 22 28.0004C21.9975 28.5529 21.5494 29 21.0046 29ZM16 21V23H20.1C20.25 22.2611 20.5629 21.5814 20.9996 21H16ZM12 13V15H18V13H12ZM14 17V19H20V17H14ZM14 25V27H20V25H14ZM25 27C26.6569 27 28 25.6569 28 24C28 22.3432 26.6569 21 25 21C23.3431 21 22 22.3432 22 24C22 25.6569 23.3431 27 25 27Z"
      fill="white"
    />
  </svg>
);

export default IconMoney;
